require("!!/home/uplanner/rosario-front/node_modules/script-loader/addScript.js")(require("!!/home/uplanner/rosario-front/node_modules/raw-loader/index.js!/home/uplanner/rosario-front/bower_components/highcharts/modules/data.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/highcharts/modules/data.js
// module id = 1509
// module chunks = 0